import { render, staticRenderFns } from "./OtherExpenses.vue?vue&type=template&id=130259ee&scoped=true&"
import script from "./OtherExpenses.vue?vue&type=script&lang=js&"
export * from "./OtherExpenses.vue?vue&type=script&lang=js&"
import style0 from "./OtherExpenses.vue?vue&type=style&index=0&id=130259ee&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "130259ee",
  null
  
)

export default component.exports